const ROUTES = {
  SYSTEMS: '/',
  LINKS: '/links',
  REQUESTS: '/requests',
}

export default ROUTES
